import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the `}<inlineCode parentName="p">{`address`}</inlineCode>{` value on an existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#delivery"
        }}>{`Delivery`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setDeliveryAddress"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`deliveryId`}</inlineCode>{` - String
The ID of the `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#delivery"
          }}>{`Delivery`}</a>{` which should be updated.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`address`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#addressdraft"
          }}>{`AddressDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`If not set an existing address is removed from the delivery.`}</li>
      </ul>
      <p parentName="section">{`This update action produces a `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#delivery-address-set"
        }}>{`DeliveryAddressSet`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      